<section class="not-found-page">
  <p class="code">404</p>
  <h1>ไม่พบหน้าที่คุณต้องการ</h1>
  <p class="description">URL นี้ไม่มีอยู่ในระบบ หรืออาจถูกย้ายตำแหน่งแล้ว</p>
  <a routerLink="/" class="back-home">กลับหน้าหลัก</a>
</section>
